import { render, staticRenderFns } from "./shopmall.vue?vue&type=template&id=64a1d454&"
import script from "./shopmall.vue?vue&type=script&lang=js&"
export * from "./shopmall.vue?vue&type=script&lang=js&"
import style0 from "./shopmall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports